// tela-aplicativo-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Abrir em Aplicativo": "Abrir en Aplicación",
    "As opções do aplicativo (Home, carrossel, abastecimento, cupons, avaliação e login) agora ficam em": "Las opciones de la app (Inicio, carrusel, carga de combustible, cupones, evaluación e inicio de sesión) ahora están en",
    "Avaliação e avisos": "Evaluación y avisos",
    "Cadastro e login": "Registro e inicio de sesión",
    "Ferramentas PontuaX": "Herramientas PontuaX",
    "Home, carrossel, abastecimento, cupons, avaliação, cadastro e os textos do app saíram de Configurações e ficam aqui, uma aba para cada tela do app.": "Inicio, carrusel, carga de combustible, cupones, evaluación, registro y los textos de la app salieron de Configuración y ahora están aquí, una pestaña para cada pantalla de la app.",
    "Identidade visual": "Identidad visual",
    "Identidade visual, lojas e build mínimo, verificação do cadastro, código temporário, “Somente encher tanque” e odômetro agora ficam em Aplicativo.": "Identidad visual, tiendas y build mínimo, verificación del registro, código temporal, “Solo llenar el tanque” y odómetro ahora están en Aplicación.",
    "Imagens do carrossel": "Imágenes del carrusel",
    "Lojas e atualização": "Tiendas y actualización",
    "Na hora de abastecer": "Al cargar combustible",
    "Novo: o aplicativo num lugar só": "Nuevo: la app en un solo lugar",
    "Regras do abastecimento no app": "Reglas de carga en la app",
    "Selecionar esta rede e abrir Aplicativo": "Seleccionar esta red y abrir Aplicación",
    "Seções da Home": "Secciones del Inicio",
    "Só a equipe PontuaX vê estas opções.": "Solo el equipo de PontuaX ve estas opciones.",
    "Textos da tela de Descontos": "Textos de la pantalla de Descuentos",
    "Topo da Home": "Parte superior del Inicio",
    "Verificação do cadastro": "Verificación del registro",
};

export default catalogo;
